import {
    parseLocationResponse,
    collections as collectionsDuck,
} from '@eb/destination-utils';

import { getPageDescription } from '../utils';
import {
    transformBrowseBucketContent,
    transformSearchBucketContent,
    transformBrandingResponse,
} from '../utils/transformation';
import { parseSuggestions } from '../utils/suggestions';

const {
    utils: { transformCollectionResponse },
} = collectionsDuck;

const _getTransformedDataFromRequest = (buckets, searchData) => {
    let transformer = transformBrowseBucketContent.bind(null, buckets);

    if (!buckets) {
        transformer = transformSearchBucketContent.bind(null, searchData);
    }

    return transformer();
};

export const getInitialData = (props) => {
    const {
        placeId,
        latitude,
        longitude,
        buckets,
        description,
        isBotRequest,
        facebookOptions,
        featureFlags,
        gaSettings,
        currentPlace,
        currentPlaceParent,
        branding = {},
        locations = {},
        suggestions = {},
        experiments = {},
        guest_id: guestId,
        location_slug: slug,
        search_id: searchId,
        search_data: searchData = {},
        all_events_url: allEventsUrl,
        http_referer: httpReferer,
        trending_search_cities: trendingSearchCities,
        current_location_coordinates: currentLocationCoordinates,
        place_type: placeType,
        user_collections: userCollections,
        user: { isAuthenticated, publicId, email: userEmail, isStaff },
        request: { session_id: sessionId },
        env: {
            isMobile,
            localeInfo: {
                // every locale can use a different twitter account and
                // facebook account, so we need to use them in order to build
                // share messages
                twitter_handle: twitterHandle,
                facebook_locale: facebookLocale,
                facebook_page: facebookPage,
                google_maps_language: googleMapsLanguage,
                country_code: countryCode,
                language_code: languageCode,
            },
            serverUrl,
            currencyFormat,
            ebDomain: domain,
            launchNewNavigationHeader,
        },
        category_article_mapping: categoryArticleMapping,
        kompariExperimentId,
        h1_prefix: h1Prefix,
        is_online: isOnline,
        botH1,
        google_maps_api_key: googleMapsApiKey,
        should_show_trending_search_page_link: shouldShowTrendingSearchPageLink,
        isGDPRCountry,
    } = props;

    const {
        entities,
        entityContext,
        pagination,
        searchCriterias = {},
    } = _getTransformedDataFromRequest(buckets, searchData);

    const cityBlurb = description || getPageDescription(currentPlace, buckets);

    return {
        pagination,
        currencyFormat,
        launchNewNavigationHeader,
        gaSettings,
        auth: {
            isAuthenticated,
        },
        location: {
            currentPlace,
            currentPlaceParent,
            cityBlurb,
            placeId,
            latitude,
            longitude,
            trendingSearchCities,
            currentLocationCoordinates,
            slug,
            placeType,
            topSuggestions: parseLocationResponse(locations),
            h1Prefix,
            isOnline,
        },
        content: {
            entities,
            entityContext,
            allEventsUrl,
            categoryArticleMapping,
        },
        share: {
            options: {
                isMobile,
                twitterHandle,
                serverUrl,
                facebookOptions: {
                    ...facebookOptions,
                    locale: facebookLocale,
                    page: facebookPage,
                },
            },
        },
        collections: transformCollectionResponse(userCollections),
        brand: transformBrandingResponse(branding, isOnline),
        suggestions: parseSuggestions(suggestions),
        search: {
            ...searchCriterias,
            searchId,
        },
        admin: {
            experimentOverride: {
                experimentName: Object.keys(experiments)[0],
                variant: experiments[Object.keys(experiments)[0]],
            },
        },
        app: {
            isBotRequest,
            sessionId,
            publicId,
            countryCode,
            googleMapsLanguage,
            httpReferer,
            domain,
            featureFlags,
            experiments,
            serverUrl,
            guestId,
            userEmail,
            languageCode,
            isGDPRCountry,
        },
        kompariExperimentId,
        botH1,
        googleMapsApiKey,
        user: {
            isStaff,
        },
        shouldShowTrendingSearchPageLink,
    };
};
